import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { InjectionSymbols, LogType, type Logger } from '@hitiq/logger';
import { AuthService } from '../state/helperServices/auth/auth.service';
import { getRouteByAccountType } from './getRouteByAccountType';
import { di } from '../state/inversify.config';
import { routeRequiresLogin } from './routeHelpers';

// TODO: figure out all use cases e.g. user is redirected back to the entered url once they login or signup, on reload, ?, two tabs...
export const useAuthRedirect = () => {
  const navigator = useNavigate();
  const logger = di.get<Logger>(InjectionSymbols.LOGGER);

  const authService = di.get<AuthService>(AuthService);
  const user = authService.useLoggedInUserSelector();
  const [userChecked, setUserChecked] = useState(false);

  const previousPath = useMemo(() => window.location.pathname, []);

  useEffect(() => {
    authService.dispatchCurrentAuthenticatedUser();
    authService.listenToIsNetworkConnected();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: break out into a hook i.e. useAuth
  useEffect(() => {
    logger.log(LogType.debug, `Auth: user changed to: ${JSON.stringify(user)}`);

    // If user has been checked (verified as valid, or found to be invalid), remember it's been checked.
    if (user !== undefined && !userChecked) setUserChecked(true);

    // If user is invalid or has been cleared since being valid (logged out), redirect to login page.
    if ((user === undefined && userChecked) || user === null) {
      if (routeRequiresLogin()) navigator('/');
      return;
    }

    // If no valid user, yet, but still checking, do nothing
    if (!userChecked) {
      return;
    }

    const defaultPath = `/${getRouteByAccountType(user.accountType)}`;
    // don't navigate if user has the current accountType
    if (window.location.pathname.startsWith(defaultPath)) {
      // TODO: update memo?
      return;
    }

    if (previousPath.startsWith(defaultPath)) {
      // uses the initial route after logging in
      navigator(previousPath);
    } else {
      navigator(defaultPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, userChecked]);
};
